import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend); // Register Chart.js components

export default function TenderBarChart({ data }) {
    const { t } = useTranslation();
    const labels = Object.keys(data); // Extract labels from the data object
    const values = Object.values(data); // Extract values from the data object
    const cssColor = getComputedStyle(document.documentElement) // Get the CSS variable for color
        .getPropertyValue('--color-red-dark')
        .trim();

     //============================================================================================================   
    // Prepare the chart data structure
    //============================================================================================================
    const chartData = {
        labels,
        datasets: [{
            label: t('Value'),
            barPercentage: 0.4,       // 0.4 means 40% of the width of the category
            categoryPercentage: 0.6,  // 60% of the width of the category
            data: values,
            backgroundColor: cssColor,
        }]
    };

    //============================================================================================================
    // Calculate the maximum value for the y-axis
    //============================================================================================================
    const maxValue = Math.max(...values, 0);

    //============================================================================================================
    // Prepare the chart options
    //============================================================================================================
    const options = {
        responsive: true, // Make the chart responsive
        maintainAspectRatio: false, // Allow the chart to fill its container
        scales: {
            y: { // Configure the y-axis
                beginAtZero: true, // Start the y-axis at zero
                suggestedMax: maxValue < 10 ? 10 : undefined, // Set a suggested maximum if the max value is less than 10
                ticks: { // Customize the y-axis ticks
                    font: { size: 12, weight: 'bold' } // Set the font size and weight for the ticks
                }
            },
            x: { // Configure the x-axis
                ticks: { // Customize the x-axis ticks
                    font: { size: 12, weight: 'bold' } // Set the font size and weight for the ticks
                }
            }
        },
        plugins: { // Configure plugins
            legend: { display: false }, // Hide the legend set to false
            tooltip: { enabled: true }  // Enable tooltips
        },
        animation: { easing: 'easeOutQuart', duration: 500 } // Set animation easing and duration
    };

    //============================================================================================================
    // Render the chart
    //============================================================================================================
    return (
        <div style={{ height: '300px' }}>
            <Bar data={chartData} options={options} />
        </div>
    );
}

TenderBarChart.propTypes = {
    data: PropTypes.object.isRequired
};
